import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import jsPDF from "jspdf";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import {
  getOrderProduct,
  getPersonalDetails,
  updateStocksByHUID,
} from "../../../helpers/urlConfig/apiFunctions";
import { useParams } from "react-router-dom";
import {
  errorToastify,
  successToastify,
} from "../../../Components/Common/Toaster";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import OrderProductEdit from "./OrderProductEdit";
import DeleteComponent from "../../../Components/Common/deleteComponent/DeleteComponent";
import OrderCreate from "./OrderCreate";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EstimatedBill } from "./EstimatedBill";
import LedgersCreate from "../Reports/Ledgers/LedgersCreate";
import { documentTitle } from "../../../helpers/documentTitle";
import { newGstReport } from "./newGstReport";
import PairsModal from "../ProductTypes/PairsModal";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

const OrderProductList = () => {
  const [gstModal, setGstModal] = useState(false);
  const [goldRate, setGoldRate] = useState("");
  const [silverRate, setSilverRate] = useState("");
  const [orderProducts, setOrderProducts] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [editableData, setEditableData] = useState([]);
  const [personalDetails, setPersonalDetails] = useState([]);
  const [customer_id, setCustomerID] = useState("");
  const [hall_mark_gst, set_hall_mark_gst] = useState("");
  const [hall_mark_charge, set_hall_mark_charge] = useState("");
  const [mode_of_payment, set_mode_of_payment] = useState("");
  const [pairs_modal_list, set_pairs_modal_list] = useState(false);
  const [pairs, setPairs] = useState("");
  const [uniqueStockID, setUniqueStockID] = useState("");

  const { orderId } = useParams();
  let data = orderId.split("-")[0];

  const [order_modal_list, set_order_modal_list] = useState(false);
  const [modal_delete, setmodal_delete] = useState(false);
  const [edit_modal_list, set_edit_modal_list] = useState(false);

  const togGstModal = () => setGstModal(!gstModal);

  const [currentProduct, setCurrentProduct] = useState(null);
  const [deleteId, setDeleteProductId] = useState(null);

  const order_tog_list = () => set_order_modal_list(!order_modal_list);
  const edit_tog_list = () => set_edit_modal_list(!edit_modal_list);
  const tog_delete = () => setmodal_delete(!modal_delete);
  const tog_pairs = () => set_pairs_modal_list(!pairs_modal_list);

  /** Ledgers Create */
  const [modal_list, setmodal_list] = useState(false);
  const tog_list = () => setmodal_list(!modal_list);

  documentTitle("Sales Product");

  const fetchData = async () => {
    try {
      const body = { id: data };
      const response = await getOrderProduct(body);

      if (response.statusCode === 200) {
        setOrderProducts(response.data);
        setGoldRate(response.data[0].gold_rate);
        setCustomerID(response.data[0].customer_id);
        setSilverRate(response.data[0].silver_rate);
        set_hall_mark_charge(response.data[0].hall_mark_charge);
        set_hall_mark_gst(response.data[0].hall_mark_gst);
        set_mode_of_payment(response.data[0].mode_of_payment);

        setEditableData(response.data); // Initialize editable data
        if (orderId) {
          setCustomerName(orderId.split("-")[1] || "CustomerName");
        }
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const fetchPersonalDetails = async () => {
    try {
      const response = await getPersonalDetails();
      if (response.statusCode === 200) {
        setPersonalDetails(response.data[0]);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
    fetchPersonalDetails();
  }, []);

  const handleInputChange = (index, field, value) => {
    const updatedData = [...editableData];
    updatedData[index][field] = value;
    setEditableData(updatedData);
  };

  const handleSubmit = () => {
    setOrderProducts(editableData);
    togGstModal(); // Open modal to generate PDF
  };

  // const exportToExcel = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(editableData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Order Products");
  //   XLSX.writeFile(workbook, "OrderProducts.xlsx");
  // };

  const exportToExcel = () => {
    const exportData = editableData.map((item, index) => ({
      "SL.No": index + 1,
      "Order ID": item.order_id,
      "Tag ID": item.unique_stock_id,
      "Product Type": item.product_type_name,
      "H.M GST %": item.hall_mark_gst || "N/A",
      "H.M Charge": item.hall_mark_charge || "N/A",
      Quantity: item.quantity,
      HUID: item.huid || (item.pairs ? "Has Pairs" : "N/A"),
      Grams: item.gram,
      MC: item.mc,
      Amount: item.amount,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order Products");
    XLSX.writeFile(workbook, "OrderProducts.xlsx");
  };

  // const exportToPDF = () => {
  //   const doc = new jsPDF();
  //   doc.text(`Order Product List - ${customerName}`, 14, 10);
  //   doc.autoTable({
  //     head: [
  //       [
  //         "SL.No",
  //         "Order ID",
  //         "Product Type",
  //         "Quantity",
  //         "HUID",
  //         "Grams",
  //         "MC",
  //         "Amount",
  //       ],
  //     ],
  //     body: editableData.map((customer, index) => [
  //       index + 1,
  //       customer.order_id,
  //       customer.product_type_name,
  //       customer.quantity,
  //       customer.huid,
  //       customer.gram,
  //       customer.mc,
  //       customer.amount,
  //     ]),
  //   });
  //   doc.save("OrderProducts.pdf");
  // };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text(`Order Product List - ${customerName}`, 14, 10);

    doc.autoTable({
      startY: 15,
      head: [
        [
          "SL.No",
          "Order ID",
          "Tag ID",
          "Product Type",
          "H.M GST %",
          "H.M Charge",
          "Quantity",
          "HUID",
          "Grams",
          "MC",
          "Amount",
        ],
      ],
      body: editableData.map((item, index) => [
        index + 1,
        item.order_id,
        item.unique_stock_id,
        item.product_type_name,
        item.hall_mark_gst || "N/A",
        item.hall_mark_charge || "N/A",
        item.quantity,
        item.huid || (item.pairs ? "Has Pairs" : "N/A"),
        item.gram,
        item.mc,
        item.amount,
      ]),
    });

    doc.save("OrderProducts.pdf");
  };

  const calculteAddedVal = (order) => {
    let amount = parseInt(order.amount);
    let quantity = order.quantity;
    let mc = parseInt(order.mc);
    let goldPrice = parseInt(goldRate);
    let gram = parseFloat(order.gram);

    let basePrice = amount / 1.03;
    let basePriceGST = basePrice.toFixed(2) * 0.03;

    let total = basePriceGST + gram * goldPrice + mc;
    let totalMinusFromInitialAmt = total - amount;
    let v_added = totalMinusFromInitialAmt / goldPrice;

    return Math.abs(v_added).toFixed(3);
  };

  const updateStocks = async (orderProducts) => {
    try {
      let huidArr = [];

      const body = {
        huids: huidArr,
      };

      orderProducts.map((item) => huidArr.push(item.huid));

      const response = await updateStocksByHUID(body);
      if (response.statusCode === 200) {
        successToastify("Stocks updated successfully");
      } else {
        errorToastify("Failed to update stocks");
      }
    } catch (error) {
      console.error("Error while updating stocks", error);
    }
  };

  const handleEstimateBillClick = () => {
    EstimatedBill(
      orderProducts,
      customerName,
      personalDetails,
      togGstModal,
      goldRate,
      silverRate
    );
  };

  const handleLedgerClick = () => {
    setmodal_list(true);
  };

  const handleEditClick = (product) => {
    setCurrentProduct(product);
    set_edit_modal_list(true);
  };

  const onClickRemoveBtn = (id) => {
    setDeleteProductId(id);
    tog_delete();
  };

  const orderProductsDetailsForCreate = {
    customer_id: customer_id,
    gold_rate_op: goldRate,
    silver_rate_op: silverRate,
    hall_mark_charge: hall_mark_charge,
    hall_mark_gst: hall_mark_gst,
    mode_of_payment: mode_of_payment,
    order_ip_op: data,
  };

  const GenerateReportHandle = () => {
    updateStocks(orderProducts);
    newGstReport(orderProducts, personalDetails);
  };

  const getPairs = (data, uniqueStockId) => {
    setPairs(data);
    setUniqueStockID(uniqueStockId);
    tog_pairs();
  };

  console.log("editableData", editableData);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Sales Product List"
            pageTitle="Sales Product List"
            exportToExcel={exportToExcel}
            exportToPDF={exportToPDF}
            customerName={`${customerName}'s Sales List`}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <Button
                    color="success"
                    className="me-1"
                    onClick={order_tog_list}
                    id="create-btn"
                  >
                    <i className="ri-add-line align-bottom me-1"></i>
                  </Button>
                </CardHeader>

                <CardBody>
                  <div className="table-responsive table-card mt-3 mb-1">
                    <table className="table align-middle table-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th>SL.No</th>
                          <th>Order ID</th>
                          <th>Tag ID</th>
                          <th>Product Type</th>
                          <th>H.M GST %</th>
                          <th>H.M Charge</th>
                          <th>Quantity</th>
                          <th>HUID</th>
                          <th>Grams</th>
                          <th>MC</th>
                          <th>Amount</th>
                          <th>Partial Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {editableData.map((order, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{order.order_id}</td>
                            <td>{order.unique_stock_id}</td>
                            <td>{order.product_type_name}</td>
                            <td>{order.hall_mark_gst || "N/A"}</td>
                            <td>{order.hall_mark_charge || "N/A"}</td>
                            <td>
                              <Input
                                type="number"
                                disabled
                                value={order.quantity}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "quantity",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            {/* <td>
                              <Input
                                type="text"
                                value={order.huid}
                                disabled
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "huid",
                                    e.target.value
                                  )
                                }
                              />
                            </td> */}
                            <td>
                              {order.huid === null && order.pairs ? (
                                <button
                                  onClick={
                                    () =>
                                      getPairs(
                                        order.pairs,
                                        order.unique_stock_id
                                      )
                                    //getPairs(order)
                                  }
                                >
                                  Sets
                                </button>
                              ) : (
                                order.huid
                              )}
                            </td>
                            <td>
                              <Input
                                type="text"
                                value={order.gram}
                                disabled
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "gram",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Input
                                type="text"
                                value={order.mc}
                                disabled
                                onChange={(e) =>
                                  handleInputChange(index, "mc", e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <Input
                                type="text"
                                value={order.amount}
                                disabled
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "amount",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Input
                                type="text"
                                value={order.partial_amount || "-"}
                                disabled
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "partial_amount",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            {order.comments == null && (
                              <td>
                                <div className="d-flex gap-2">
                                  <div className="edit">
                                    <button
                                      className="btn btn-sm btn-success"
                                      onClick={() => handleEditClick(order)}
                                    >
                                      Edit
                                    </button>
                                  </div>
                                  <div className="remove">
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() =>
                                        onClickRemoveBtn(order.order_product_id)
                                      }
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {orderProducts.length > 0 && (
                    <Row className="mt-3">
                      <Col xs={12} sm="auto">
                        <Button
                          color="success"
                          className="w-100"
                          onClick={handleSubmit}
                        >
                          Generate GST Report
                        </Button>
                      </Col>{" "}
                      <Col xs={12} sm="auto">
                        <Button
                          color="primary"
                          className="w-100"
                          onClick={handleEstimateBillClick}
                          disabled
                        >
                          Generate Estimate Bill
                        </Button>
                      </Col>{" "}
                      <Col xs={12} sm="auto">
                        <Button
                          color="primary"
                          className="w-100"
                          onClick={handleLedgerClick}
                        >
                          Ledger To Customer
                        </Button>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          {edit_modal_list && (
            <OrderProductEdit
              modal_list={edit_modal_list}
              setmodal_list={set_edit_modal_list}
              tog_list={edit_tog_list}
              fetchData={fetchData}
              currentProduct={currentProduct}
            />
          )}

          <DeleteComponent
            modal_delete={modal_delete}
            tog_delete={tog_delete}
            fetchData={fetchData}
            deleteId={deleteId}
            keyName="Order Product"
          />
          <Modal isOpen={gstModal} toggle={togGstModal}>
            <ModalHeader toggle={togGstModal}>Enter Gold Rate</ModalHeader>
            <ModalBody>
              <Label for="goldRate">Gold Rate</Label>
              <Input
                type="number"
                id="goldRate"
                value={goldRate}
                onChange={(e) => setGoldRate(e.target.value)}
              />
              <Label for="goldRate">Silver Rate</Label>
              <Input
                type="number"
                id="silverRate"
                value={silverRate}
                onChange={(e) => setSilverRate(e.target.value)}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={GenerateReportHandle}>
                Generate Report
              </Button>
              <Button color="secondary" onClick={togGstModal}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>

      <OrderCreate
        order_modal_list={order_modal_list}
        set_order_modal_list={set_order_modal_list}
        order_tog_list={order_tog_list}
        fetchData={fetchData}
        /** create order from order product list */
        orderProductsDetailsForCreate={orderProductsDetailsForCreate}
      />

      <LedgersCreate
        modal_list={modal_list}
        setmodal_list={setmodal_list}
        tog_list={tog_list}
        fetchData={fetchData}
        customer_id={customer_id}
      />

      {pairs_modal_list && (
        <PairsModal
          pairs={JSON.parse(JSON.parse(JSON.stringify(pairs)))}
          uniqueStockID={uniqueStockID}
          pairs_modal_list={pairs_modal_list}
          tog_pairs={tog_pairs}
          fetchData={fetchData}
          keyName="Sales"
        />
      )}
      <ToastContainer />
    </>
  );
};

export default OrderProductList;
